import { render, staticRenderFns } from "./ButtonWithDropdown.vue?vue&type=template&id=2a25bd32&"
import script from "./ButtonWithDropdown.vue?vue&type=script&lang=js&"
export * from "./ButtonWithDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports